// Swedish

const lang = {
  gateMediaPreviewHeader: 'Du kanske också gillar',
  loadmore: 'Visa mer',
  nextMedia: 'Nästa media',
  previousMedia: 'Tidigare media',
  closePost: 'Stäng inlägg',
  nextPost: 'Nästa inlägg',
  previousPost: 'Tidigare inlägg',
  outOfStock: 'Slut i lager',
  numberOfReviews(n) {
    return n === 1 ? 'omdöme' : 'omdömen'
  },
  reportFormField: 'Skriv ett meddelande',
  reportPost: 'Anmäl post',
  reportFormTitle: 'Vill du anmäla den här bilden?',
  reportFormDetails:
    'Om du anser att bilden är olämplig, misstänker att den bryter mot lagen eller inkräktar på någons rättigheter kan du rapportera innehållet. Om du rapporterar bilden/texten kommer innehållsmoderatorerna att meddelas och lämpliga åtgärder vidtas.',
  reportFormMessagePlaceholder: 'Skäl för anmälan',
  reportFormMessageLabel: 'Meddelande',
  reportFormEmailLabel: 'Din email',
  reportFormSubmitButtonText: 'Anmäl',
  reportFormCancelButtonText: 'Avbryt',
  reportFormSentTitle: 'Tack för din anmälan!',
  reportFormSentCloseButtonText: 'Stäng',
  cardAndTileAriaLabel: 'Nedan är en lista med poster från olika sociala medier',
  carouselAriaLabel: 'Nedan är en karusell med poster från olika sociala medier',
  singleAriaLabel: 'Nedan är ett inlägg från ett socialt medie-konto',
  poweredBy: 'Drivs av Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` publicerad ${date}` : ''
    const createdByString = userName ? ` skapad av ${userName}` : ''
    return `Foto${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Ladda upp din media',
  openTheGate: 'Öppna dialogrutan',
}

export default lang
